import { render, staticRenderFns } from "./PlcItemDetail.vue?vue&type=template&id=0388e637&scoped=true"
import script from "./PlcItemDetail.vue?vue&type=script&lang=js"
export * from "./PlcItemDetail.vue?vue&type=script&lang=js"
import style0 from "./PlcItemDetail.vue?vue&type=style&index=0&id=0388e637&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388e637",
  null
  
)

export default component.exports